import { c as _c } from "react/compiler-runtime";
import { readFragment } from "@opensea/graphql";
import { Chip, UnstyledButton } from "@opensea/ui-kit";
import { ItemOwnersModal } from "../../ItemOwnersModal/ItemOwnersModal";
import { ItemOwnersChipFragment } from "./ItemOwnersChip.fragment";
import { ItemOwnersCount } from "./ItemOwnersCount";
export function ItemOwnersChip(t0) {
  const $ = _c(7);
  const {
    item: itemKey
  } = t0;
  let t1;
  if ($[0] !== itemKey) {
    t1 = readFragment(ItemOwnersChipFragment, itemKey);
    $[0] = itemKey;
    $[1] = t1;
  } else {
    t1 = $[1];
  }
  const item = t1;
  if (!item.isFungible) {
    return null;
  }
  let t2;
  if ($[2] !== item) {
    t2 = <UnstyledButton><Chip className="gap-1"><ItemOwnersCount item={item} /></Chip></UnstyledButton>;
    $[2] = item;
    $[3] = t2;
  } else {
    t2 = $[3];
  }
  let t3;
  if ($[4] !== item || $[5] !== t2) {
    t3 = <ItemOwnersModal item={item}>{t2}</ItemOwnersModal>;
    $[4] = item;
    $[5] = t2;
    $[6] = t3;
  } else {
    t3 = $[6];
  }
  return t3;
}